<template>
  <v-col>
    <v-data-table
      :headers="headers"
      :items="contrats"
      class="elevation-1"
      loading="true"
      :items-per-page="20"
      dense
      v-if="contrats.length > 0"
    >
      <template v-slot:[`item.typeSituation`]="{ item }">
        {{ typeSituationFonction(item) }}
      </template>
      <template v-slot:[`item.temoinFormComp`]="{ item }">
        <v-checkbox
          class="my-n4 py-n4"
          :input-value="item.temoinFormComp"
          @change="changementFormComp(item)"
          dense
        ></v-checkbox>
      </template>
      <template v-slot:[`item.libelleCourtType`]="{ item }">
        <v-tooltip bottom color="info" max-width="150px">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">{{ item.libelleCourtType }}</span>
          </template>
          <span>{{ item.libelleType }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.libelleCourtSousType`]="{ item }">
        <v-tooltip bottom color="info" max-width="150px">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">
              {{ item.libelleCourtSousType }}
            </span>
          </template>
          <span>{{ item.libelleSousType }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.delete`]="{ item }">
        <v-btn
          color="error"
          icon
          small
          @click="suppressionContrat(item)"
          :disabled="!conditionSuppression(item)"
        >
          <v-icon>mdi-delete-variant</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-btn color="success" @click="sauvegarder"
      >Sauvegarder les changements</v-btn
    >
    <v-btn color="success" @click="ouvrirAjout">Ajouter un contrat</v-btn>
    <v-dialog v-model="dialogAjouter" persistent>
      <BaseBlock>
        <v-form v-model="validAjout" lazy-validation ref="formAjout">
          <v-radio-group
            label="Type Situation"
            v-model="contrat.typeSituation"
            required
            :rules="[(value) => !!value || 'Champ requis.']"
          >
            <v-radio
              v-for="item in typeSituation"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></v-radio>
          </v-radio-group>

          <v-radio-group
            label="Type Emploi"
            v-model="contrat.typeEmploi"
            required
            :rules="[(value) => !!value || 'Champ requis.']"
          >
            <v-radio
              v-for="item in typeEmploi"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></v-radio>
          </v-radio-group>

          <v-text-field
            v-model="contrat.codeType"
            label="Code Type"
            :rules="[
              (value) => !!value || 'Champ requis.',
              (value) =>
                (value && value.length < 7) || 'maximum de caractères : 3.',
            ]"
            required
          ></v-text-field>
          <!-- <v-text-field
            v-model="contrat.codeSousType"
            label="Code Sous-Type"
            required
            :rules="[
              (value) => value.length < 4 || 'maximum de caractères : 3.',
            ]"
          ></v-text-field> -->

          <v-btn color="success" @click="ajoutContrat" :disabled="!validAjout"
            >Valider</v-btn
          >
          <v-btn color="info" @click="annulerAjout">Annuler</v-btn>
        </v-form>
      </BaseBlock>
    </v-dialog>
  </v-col>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiIndividuRepository from "@/repositories/ApiIndividuRepository";

export default {
  components: { BaseBlock },
  data() {
    return {
      contrats: [],
      contrat: {
        codeType: "",
        codeSousType: "",
        typeEmploi: "",
        typeSituation: "",
      },
      headers: [
        { text: "Type de situation", value: "typeSituation" },
        { text: "Type d'emploi", value: "typeEmploi" },
        { text: "Code Type", value: "codeType" },
        { text: "Libelle du Type", value: "libelleCourtType" },
        // { text: "Code Sous-type", value: "codeSousType"},
        // { text: "Libelle du sous-type", value: "libelleCourtSousType" },
        { text: "Temoin Complémentaire", value: "temoinFormComp" },
        { text: "Action", value: "delete" },
      ],
      dialogAjouter: false,
      validAjout: true,
      typeEmploi: [
        { value: 1, name: "BIATSS" },
        { value: 2, name: "ENSEIGNANT" },
      ],
      typeSituation: [
        { value: "F", name: "Fonctionnaire" },
        { value: "C", name: "Contractuel" },
      ],
    };
  },
  async created() {
    this.contrats = await ApiIndividuRepository.getAllContratCarrieres();
  },
  methods: {
    changementFormComp(item) {
      if (item.temoinFormComp) item.temoinFormComp = false;
      else item.temoinFormComp = true;
    },
    async ajoutContrat() {
      if (this.$refs.formAjout.validate()) {
        if (
          this.contrat.codeType.length < 7 &&
          this.contrat.codeSousType.length < 4
        ) {
          this.contrat.codeType = this.contrat.codeType.toUpperCase();
          if (this.contrat.codeSousType.length > 0)
            this.contrat.codeSousType = this.contrat.codeSousType.toUpperCase();
          this.contrat = await ApiIndividuRepository.saveContratCarriere(
            this.contrat
          );
          this.contrats.push(this.contrat);
          this.annulerAjout();
        } else {
          this.$toast.warn(
            "Le code type ou le code sous type possède trop de caractères."
          );
        }
      }
    },
    async suppressionContrat(item) {
      if (this.conditionSuppression(item)) {
        await ApiIndividuRepository.deleteContratCarriere(item.id);
        this.contrats = this.contrats.filter((element) => element != item);
      } else {
        this.$toast.warn("Vous ne pouvez pas supprimer ce type de contrat.");
      }
    },
    conditionSuppression(item) {
      return (
        (item.codeType != null && item.libelleType == null) ||
        (item.codeSousType != null && item.libelleSousType == null)
      );
    },
    async sauvegarder() {
      this.contrats = await ApiIndividuRepository.saveAllContratCarrieres(
        this.contrats
      );
    },
    ouvrirAjout() {
      this.dialogAjouter = true;
    },
    annulerAjout() {
      this.contrat = Object.assign({});
      this.$refs.formAjout.reset();
      this.dialogAjouter = false;
    },
    typeSituationFonction(item) {
      var situation = "";
      this.typeSituation.forEach((element) => {
        if (element.value == item.typeSituation) {
          situation = element.name;
        }
      });
      return situation;
    },
  },
};
</script>
